import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const DigilockerListDocumentsInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-list', title: 'Digilocker List Documents', subtitle: 'List documents available in a Digilocker session' }}
        fields={[
            { name: 'clientId', label: 'Client ID', icon: 'pi-key', placeholder: 'digilocker_xxxxxxxxx', maxLength: 100, mono: true,
              colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{
            method: 'GET',
            path: '/surepass/digilocker/list-documents',
            bodyMapper: (v, sid) => ({ client_id: v.clientId.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="digilocker-list-documents"
        submitLabel="List Documents"
        successSummary="Documents fetched"
        errorSummary="List documents failed"
        confirmHeader="Confirm Digilocker document list"
        confirmAcceptLabel="Yes, list"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Digilocker Documents', icon: 'pi-list' }}
    />
);

export default DigilockerListDocumentsInputComponent;
